function isEmptyOrSpaces(value?: string) {
  return !value || value?.trim() === '';
}

export { isEmptyOrSpaces };
